"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attCategoriesArray = void 0;
exports.attCategoriesArray = [
    "GUARDIA_RANDOM",
    "GUARDIA_MEDICO",
    "GUARDIA_AUTONOMOUS",
    "GUARDIA_UMACARE",
    "MI_ESPECIALISTA",
    "CONSULTORIO",
    "CHAT",
    "QUICKPRESCRIPTION",
    "ON_DEMAND",
    "FITNESS_CERTIFICATE",
];
